<template>
    <div id="fab" class="fixed-action-btn" @click="addDevice">
        <a class="btn-floating btn-large red ripple dark">
            <img src="img/plus.png" width="20" style="display:block; margin:auto; padding-top: 20px">
        </a>
    </div>
</template>

<script>
    export default {
        name: "FloatingActionButton",

        methods: {
            addDevice() {
                this.$root.$emit('bv::show::modal', 'addDeviceModal');
            }
        }
    }
</script>

<style scoped>
    .fixed-action-btn {
        position: fixed;
        right: 35px;
        bottom: 25px;
        padding-top: 15px;
        margin-bottom: 0;
        z-index: 997;
    }

    .btn-floating.btn-large {
        width: 60px;
        height: 60px;
        padding: 0;
        box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2), 0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
    }

    .btn-large {
        height: 54px;
        line-height: 54px;
        font-size: 15px;
        padding: 0 28px;
    }

    .red {
        background-color: #f8262a !important;
    }

    .btn-floating {
        display: inline-block;
        color: #fff;
        position: relative;
        overflow: hidden;
        z-index: 1;
        width: 40px;
        height: 40px;
        line-height: 40px;
        padding: 0;
        background-color: #26a69a;
        border-radius: 50%;
        -webkit-transition: background-color .3s;
        transition: background-color .3s;
        cursor: pointer;
        vertical-align: middle;
    }

    .btn-floating i {
        width: inherit;
        display: inline-block;
        text-align: center;
        color: #fff;
        font-size: 2rem;
        line-height: 40px;
    }

    .btn-floating.btn-large i {
        line-height: 56px;
    }
</style>
